const states = {
    PENDING_SUPPORT : 'PENDING_SUPPORT'
    , SEEKING_FUNDING : 'SUPPORTED',
    ROUND_CLOSED: 'ROUND_CLOSED'
    , APPROVED_BY_IT : 'APPROVED_BY_IT'
    , PILOT_ACTIVE : 'PILOT_ACTIVE'
    // , IMPLEMENTED : 'IMPLEMENTED'
    , DISCARDED : 'DISCARDED'
    , PENDING_VALIDATION : 'PENDING_VALIDATION'
    , DRAFT : 'DRAFT',
    SELECTED_FOR_HACKATHON : 'SELECTED_FOR_HACKATHON',
    IMPLEMENTED_PIR:"IMPLEMENTED_PIR",
    EVALUATING:'EVALUATING',
    INVESTIGATING:'INVESTIGATING',
    INCUBATING:'INCUBATING',
    IMPLEMENTING:'IMPLEMENTING',
    IMPLEMENTED:'IMPLEMENTED',
    BACKLOG:'BACKLOG',
    NO_APETITE:'NO_APETITE',
    NOT_NEW:'NOT_NEW',
    IDEA_CLOSED:'IDEA_CLOSED',
}
export default states